import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, BrainIcon, BarChart3Icon, SparklesIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const MEDIA_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/494ff191-f51a-4ff9-aff3-badd2f9dd180.jpg';
const DIFFERENCE = [{
  icon: GlobeIcon,
  title: 'Pan-African Expertise',
  text: 'Active engagements spanning East and West Africa — not a single-market view.'
}, {
  icon: BrainIcon,
  title: 'Senior Strategic Thinking',
  text: 'Every account is guided by senior counsel, not junior execution alone.'
}, {
  icon: BarChart3Icon,
  title: 'Data-Led Decisions',
  text: 'Campaign and media performance tracked and reported against clear metrics.'
}, {
  icon: SparklesIcon,
  title: 'Creative Excellence',
  text: 'Communications built to earn attention, not just fill a calendar.'
}, {
  icon: UsersIcon,
  title: 'Meaningful Partnerships',
  text: 'Long-term relationships with media, industry, and stakeholder networks.'
}, {
  icon: TrendingUpIcon,
  title: 'Measurable Growth',
  text: 'Every engagement tied to a defined outcome: reach, revenue, or reputation.'
}];
export function WhyUs() {
  return <section id="why" className="w-full bg-ivory py-24 md:py-32" data-id="element-146" data-mp="3s386vw2ckx7o">
      <div className="max-w-7xl mx-auto px-6" data-id="element-147" data-mp="w5gh6uc2uyi">
        <div className="grid lg:grid-cols-2 gap-12 items-end" data-id="element-148" data-mp="vdk3tswwt76">
          <SectionHeading eyebrow="Why Flicker Africa" title="Because Africa deserves more than generic marketing." subtitle="We combine local market intelligence with international standards to create solutions that are strategic, measurable, and built for long-term success — backed by hands-on experience across summit communications, multi-market media buys, and brand market-entry campaigns." data-id="element-149" data-mp="5ugord4zcxem" />
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="overflow-hidden rounded-2xl" data-id="element-150" data-mp="2gnb7tf0sowwq">
            <img src={MEDIA_IMG} alt="Modern African urban media environment at night" className="w-full h-64 object-cover" data-id="element-151" data-mp="3szeuj8uehjev" />
          </motion.div>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-navy/10 rounded-2xl overflow-hidden border border-navy/10" data-id="element-152" data-mp="6pkmak7jbl6y">
          {DIFFERENCE.map((d, i) => {
          const Icon = d.icon;
          return <motion.div key={d.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.45,
            delay: i * 0.06
          }} className="bg-ivory p-8 hover:bg-white transition-colors" data-id="element-153" data-mp="bi5e5g6vro7u" data-mpi={i}>
                <Icon className="text-emerald" size={24} data-id="element-154" data-mp="145euw9refp5m" />
                <h3 className="mt-5 font-serif text-2xl text-navy" data-id="element-155" data-mp="193ycxz2vggsp">{d.title}</h3>
                <p className="mt-2 text-graphite/80 leading-relaxed" data-id="element-156" data-mp="v4gm7e60mtgp">{d.text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}